import React from 'react'
import { IState } from 'store'
import { connect } from 'react-redux'
import { Grid } from '../../../base/components/ui/Grid'
import { Title } from '../../shared/ui/Title'
import ModelChart from '../../shared/ui/ModelChart'
import { simulationService, outputs } from '../../../services/SimulationService'
import { IStoredRun } from '../../../store/state'
import styles from './Charts.module.scss'

interface Props {
  values: TObjectAny
  storedRuns: IStoredRun[]
}

const ViewSimulationCharts = ({ values, storedRuns }: Props) => {
  const run = React.useMemo(() => simulationService.calcRun(values), [values])

  const activeStoredRuns = React.useMemo(() => storedRuns.filter(i => i.isActive).reverse(), [storedRuns])
  const chartData1 = React.useMemo(() => [run[0], ...activeStoredRuns.map(r => r.run[0])], [run, activeStoredRuns])
  const chartData2 = React.useMemo(() => [run[1], ...activeStoredRuns.map(r => r.run[1])], [run, activeStoredRuns])
  const chartData3 = React.useMemo(() => [run[2], ...activeStoredRuns.map(r => r.run[2])], [run, activeStoredRuns])
  const chartData4 = React.useMemo(() => [run[3], ...activeStoredRuns.map(r => r.run[3])], [run, activeStoredRuns])
  const colors1 = React.useMemo(() => getColorSet(0, activeStoredRuns), [chartData1])
  const colors2 = React.useMemo(() => getColorSet(1, activeStoredRuns), [chartData2])
  const colors3 = React.useMemo(() => getColorSet(2, activeStoredRuns), [chartData3])
  const colors4 = React.useMemo(() => getColorSet(3, activeStoredRuns), [chartData4])

  return (
    <Grid className={styles.root} container spacing={24} mt={16}>
      <Grid item md={12} lg={6}>
        <Title type={'h3'}>{outputs[0][1]}</Title>
        <ModelChart colors={colors1} data={chartData1} />
      </Grid>
      <Grid item md={12} lg={6}>
        <Title type={'h3'}>{outputs[1][1]}</Title>
        <ModelChart colors={colors2} data={chartData2} />
      </Grid>
      <Grid item md={12} lg={6}>
        <Title type={'h3'}>{outputs[2][1]}</Title>
        <ModelChart colors={colors3} data={chartData3} />
      </Grid>
      <Grid item md={12} lg={6}>
        <Title type={'h3'}>{outputs[3][1]}</Title>
        <ModelChart colors={colors4} data={chartData4} />
      </Grid>
    </Grid>
  )
}

const getColorSet = (key: number, runs: IStoredRun[]) => {
  const colorSet: string[] = []
  colorSet.push('rgba(0, 157, 196, 1)')
  runs.forEach(r => {
    colorSet.push(r.color)
  })
  return colorSet
}

const mapStateToProps = (state: IState, ownProps: any): Props => ({
  values: state.app.simulation.values,
  storedRuns: state.app.simulation.storedRuns,
})

const Connected = connect(mapStateToProps)(ViewSimulationCharts)
export { Connected as ViewSimulationCharts }
